import { render } from "./AdditionalActsManager.vue?vue&type=template&id=6765f752"
import script from "./AdditionalActsManager.vue?vue&type=script&lang=js"
export * from "./AdditionalActsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__